import { MenuChatEffort } from "../state/atoms";

const TKN = "tkn";
const REG = "reg";
const MENU_CHAT_EFFORT = "menuChatTier";

const Storage = {
  setToken(memberId: string) {
    window.localStorage.setItem(TKN, memberId);
  },

  getToken(): string {
    return window.localStorage.getItem(TKN) || "";
  },

  removeToken() {
    window.localStorage.removeItem(TKN);
  },

  setRegisterFlag(flag: string) {
    window.localStorage.setItem(REG, flag);
  },

  getRegisterFlag(): string {
    return window.localStorage.getItem(REG) || "";
  },

  removeRegisterFlag() {
    console.log("Removing register flag");
    window.localStorage.removeItem(REG);
  },

  setMenuChatEffort(effort: MenuChatEffort) {
    window.localStorage.setItem(MENU_CHAT_EFFORT, effort);
  },

  getMenuChatEffort(): MenuChatEffort {
    const stored = window.localStorage.getItem(MENU_CHAT_EFFORT);
    return stored === "HIGH" || stored === "PRO" ? stored : "NORMAL";
  },
};

export default Storage;
